module.exports = __webpack_public_path__ + "img/video2.203786e4.svg";